<template>
  <popup :close-action="closeActionClicked" :buttons="buttons" class="onthemap-challenge-popup">
    <template v-slot:title>
      <div class="title-image">
        <img :src="require('@/assets/challenges/onthemap2022.svg')">
      </div>
      <div class="title-text">ביום העצמאות הזה, קהילת רייזאפ שמה את עצמה על המפה</div>
    </template>
    <template v-slot:content>
      <div class="onthemap-challenge-content">
        <div>ביחד נוכיח שבכל עיר ובכל שכונה במדינה יש לפחות בית אחד שמתעקש להיות אופטימי, שמניף דגל של עוצמה אל מול יוקר המחיה.
          זה הזמן לשים גם את עצמך על המפה,
          ולהיות חלק מקהילה של עשרות אלפי ישראלים וישראליות שבוחרים בדרך של צמיחה.
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../Segment';

export default {
  name: 'OnTheMapChallengePopup',
  components: {
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('OnTheMapChallengePopupShown');
  },
  computed: {
    buttons() {
      return [{
        title: 'שימו אותי על המפה💪',
        action: this.openLink,
        variant: 'primary',
        size: 'slim',
      }];
    },
  },
  methods: {
    ...mapActions('onthemapChallenge', ['setPopupClosed']),
    closeActionClicked() {
      Segment.trackUserInteraction('OnTheMapChallengePopup_CloseButtonClicked');
      this.close();
    },
    openLink() {
      Segment.trackUserInteraction('OnTheMapChallengePopup_TellMeMoreClicked');
      window.open('https://map.riseup.co.il/', '_blank');
      this.close();
    },
    close() {
      this.setPopupClosed();
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">

.onthemap-challenge-popup .title {}

.onthemap-challenge-popup {
  .title-text {
    text-align: center;
    font-family: SimplerProBold;
    line-height: 1.1;
    font-size: 29px;
  }

  .title-image {
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 25%;
      margin-bottom: 26px;
    }
  }
  .onthemap-challenge-content {
    line-height: 1.5;
    text-align: center;
    font-size: 18px;

    div {
      margin-bottom: 20px;
    }
  }

}
</style>
